import { ComboCard, DailyCombo, DailyComboModel } from '@/core/interfaces';

export const UserDailyComboMapper = ({
	rewardCollected,
	userComboCards,
}: DailyComboModel): DailyCombo => {
	let comboCards: ComboCard[] = [];
	if (userComboCards.length > 0) {
		userComboCards.map((combo) => {
			comboCards.push({
				id: combo.id,
				image: combo.imageUrl,
				title: combo.thumbnail.title,
				description: combo.thumbnail.description,
			});
		});
	}

	const userDailyComboData: DailyCombo = {
		rewardCollected,
		userComboCards: comboCards,
	};

	return userDailyComboData;
};
